import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import React from 'react'
import { CriteriaType } from '../../../state'
import { CriteriaTypeIcon } from '../../shared/CriteriaTypeIcon'
import { CriteriaTypeLabel } from '../../shared/CriteriaTypeLabel'
import { CRITERIA_ORDER } from '../base/CohortEditComponent'

export interface CriteriaSelectionMenuProps {
    anchorEl: HTMLElement | null
    open: boolean
    onClose: () => void
    onCriteriaSelect: (criteriaType: CriteriaType) => void
    anchorOrigin?: {
        vertical: 'top' | 'center' | 'bottom'
        horizontal: 'left' | 'center' | 'right'
    }
    transformOrigin?: {
        vertical: 'top' | 'center' | 'bottom'
        horizontal: 'left' | 'center' | 'right'
    }
    testIdPrefix?: string
    maxHeight?: number
    width?: number
}

/**
 * A reusable menu component for selecting criteria types.
 * Used across different components for AND, OR, RELATE, and other criteria selection menus.
 */
export const CriteriaSelectionMenu: React.FunctionComponent<CriteriaSelectionMenuProps> = ({
    anchorEl,
    open,
    onClose,
    onCriteriaSelect,
    anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
    transformOrigin = { vertical: 'top', horizontal: 'left' },
    testIdPrefix = 'criteria-menu-item',
    maxHeight = 300,
    width = 220
}) => {
    const handleCriteriaSelect = (criteriaType: CriteriaType) => {
        onCriteriaSelect(criteriaType)
        onClose()
    }

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            PaperProps={{
                style: {
                    maxHeight,
                    width
                }
            }}
        >
            {CRITERIA_ORDER.map((criteriaType) => (
                <MenuItem key={criteriaType} onClick={() => handleCriteriaSelect(criteriaType)} data-testid={`${testIdPrefix}-${criteriaType}`}>
                    <ListItemIcon>
                        <CriteriaTypeIcon criteriaType={criteriaType} />
                    </ListItemIcon>
                    <ListItemText>
                        <CriteriaTypeLabel criteriaType={criteriaType} />
                    </ListItemText>
                </MenuItem>
            ))}
        </Menu>
    )
}
